import { AppDispatch } from '../../data/store';

interface ITaskDetail {
  tripLegInternalNoteID: string;
}

enum TaskEventType {}
// TaskCanceled = 'TaskCanceled',
// TaskResolved = 'TaskResolved',
// TaskCreated = 'TaskCreated',
// TaskEscalated = 'TaskEscalated',

/**
 * Method for handling all Task Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updateTask(
  dispatch: AppDispatch,
  detailType: string,
  detail: ITaskDetail,
) {
  // switch (detailType) {}
}

export { TaskEventType, updateTask };
